import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      if (api.isAuthenticated()) {
        try {
          const me = await api.getMe();
          setUser(me);
        } catch {
          api.clearTokens();
        }
      }
      setIsAuthChecked(true);
    };
    init();
  }, []);

  const login = async (email, password) => {
    const data = await api.login(email, password);
    const me = await api.getMe();
    setUser(me);
    return me;
  };

  const logout = async () => {
    await api.logout();
    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ user, isAuthChecked, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
